export default __webpack_public_path__ + "static/media/p2p-hover.bd8ca846.webp";